import React from 'react';
import type { CSSProperties } from 'react';

export interface IIconProps {
    className?: string;
    style?: CSSProperties;
}

function IconMinus(props: IIconProps): JSX.Element {
    return (
        <svg
            style={props.style}
            className={`${props.className ?? ''} svg-inline--fa fa-circle-minus`}
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="circle-minus"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path
                fill="currentColor"
                d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM352 280h-192C146.8 280 136 269.2 136 256c0-13.2 10.8-24 24-24h192C365.2 232 376 242.8 376 256C376 269.2 365.2 280 352 280z"
            ></path>
        </svg>
    );
}

export default IconMinus;
